<template>
  <b-modal id="duty-station" ref="modal" size="lg" title="Add" @show="resetModal" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Company Name</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.companies" v-model="input_data.company" :reduce="company =>company.code"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty Station</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.duty_station" v-model="input_data.duty_station"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Department</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.departments" v-model="input_data.department"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Unit</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.units" v-model="input_data.unit"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.issue_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
export default {
  name: "DutyStationInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BButton,
    BModal,
    vSelect
  },
  data(){
    return {
      input_data:{
        company:"",
        duty_station:"",
        department:"",
        unit:"",
        issue_date:"",
        expiration_date:""
      },
      options:{
        companies:[],
        duty_station:[],
        departments:[],
        units:[]
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    onSubmit(){

    },
    handleOk(){

    },
    resetModal(){
      this.items = []

    },
  },
}
</script>